import BillingsPlanEntryTaxiDriverAddRequest, {
  BillingsPlanEntryTaxiDriverAddRequestBillingNode,
  BillingsPlanEntryTaxiDriverAddRequestBonusContribution,
  BillingsPlanEntryTaxiDriverAddRequestBonusContributionFavorableDistance,
  BillingsPlanEntryTaxiDriverAddRequestBonusContributionOther,
  BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContribution,
  BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContributionBaseAmountExternalTaxi,
  BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContributionOtherRate,
  BillingsPlanEntryTaxiDriverAddRequestContribution,
  BillingsPlanEntryTaxiDriverAddRequestContributionType,
  BillingsPlanEntryTaxiDriverAddRequestPenaltyContribution,
  BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionBeingLate,
  BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionIncompatibleCar,
  BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionOther,
  BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionWrongRoute,
} from "../../../../../api/raily/billings/plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add.request";
import BillingsPlanEntryTaxiDriverAddParams, {
  BillingsPlanEntryTaxiDriverAddParamsBillingNode,
  BillingsPlanEntryTaxiDriverAddParamsBonusContribution,
  BillingsPlanEntryTaxiDriverAddParamsBonusContributionFavorableDistance,
  BillingsPlanEntryTaxiDriverAddParamsBonusContributionOther,
  BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContribution,
  BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContributionBaseAmountExternalTaxi,
  BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContributionOtherRate,
  BillingsPlanEntryTaxiDriverAddParamsContribution,
  BillingsPlanEntryTaxiDriverAddParamsContributionType,
  BillingsPlanEntryTaxiDriverAddParamsPenaltyContribution,
  BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionBeingLate,
  BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionIncompatibleCar,
  BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionOther,
  BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionWrongRoute,
} from "./billings-plan-entry-taxi-driver-add-params";

const createBillingBonusContributionFavorableDistance = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsBonusContributionFavorableDistance,
): BillingsPlanEntryTaxiDriverAddRequestBonusContributionFavorableDistance => {
  return {
    comment: contribution.comment,
    distance: contribution.distance,
    rate: contribution.rate,
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.BONUS_FAVORABLE_DISTANCE,
  };
};

const createBillingBonusContributionOther = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsBonusContributionOther,
): BillingsPlanEntryTaxiDriverAddRequestBonusContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.BONUS_OTHER,
  };
};

const createBillingBonusContribution = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsBonusContribution,
): BillingsPlanEntryTaxiDriverAddRequestBonusContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.BONUS_FAVORABLE_DISTANCE:
      return createBillingBonusContributionFavorableDistance(
        contribution as BillingsPlanEntryTaxiDriverAddParamsBonusContributionFavorableDistance,
      );
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.BONUS_OTHER:
      return createBillingBonusContributionOther(
        contribution as BillingsPlanEntryTaxiDriverAddParamsBonusContributionOther,
      );
  }
};

const createBillingPenaltyOther = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionOther,
): BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.PENALTY_OTHER,
  };
};

const createBillingPenaltyIncompatibleCar = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionIncompatibleCar,
): BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionIncompatibleCar => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.PENALTY_INCOMPATIBLE_CAR,
  };
};

const createBillingPenaltyBeingLate = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionBeingLate,
): BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionBeingLate => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.PENALTY_BEING_LATE,
  };
};

const createBillingPenaltyWrongRoute = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionWrongRoute,
): BillingsPlanEntryTaxiDriverAddRequestPenaltyContributionWrongRoute => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.PENALTY_WRONG_ROUTE,
  };
};

const createBillingPenaltyContribution = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsPenaltyContribution,
): BillingsPlanEntryTaxiDriverAddRequestPenaltyContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_BEING_LATE:
      return createBillingPenaltyBeingLate(
        contribution as BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionBeingLate,
      );
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_OTHER:
      return createBillingPenaltyOther(
        contribution as BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionOther,
      );
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
      return createBillingPenaltyIncompatibleCar(
        contribution as BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionIncompatibleCar,
      );
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyWrongRoute(
        contribution as BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionWrongRoute,
      );
  }
};

const createBillingContractCorrectionContributionBaseAmountExternalTaxi = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContributionBaseAmountExternalTaxi,
): BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContributionBaseAmountExternalTaxi => {
  return {
    amount: contribution.amount,
    distance: contribution.distance,
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.BASE_AMOUNT_EXTERNAL_TAXI,
  };
};

const createBillingContractCorrectionContributionOtherRate = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContributionOtherRate,
): BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContributionOtherRate => {
  return {
    rate: contribution.rate,
    type: BillingsPlanEntryTaxiDriverAddRequestContributionType.CONTRACT_CORRECTION_RATE,
  };
};

const createBillingContractCorrectionContribution = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContribution,
): BillingsPlanEntryTaxiDriverAddRequestContractCorrectionContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.BASE_AMOUNT_EXTERNAL_TAXI:
      return createBillingContractCorrectionContributionBaseAmountExternalTaxi(
        contribution as BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContributionBaseAmountExternalTaxi,
      );
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.CONTRACT_CORRECTION_RATE:
      return createBillingContractCorrectionContributionOtherRate(
        contribution as BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContributionOtherRate,
      );
  }
};

const createBillingContribution = (
  contribution: BillingsPlanEntryTaxiDriverAddParamsContribution,
): BillingsPlanEntryTaxiDriverAddRequestContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.BONUS_FAVORABLE_DISTANCE:
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.BONUS_OTHER:
      return createBillingBonusContribution(
        contribution as BillingsPlanEntryTaxiDriverAddParamsBonusContribution,
      );
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_BEING_LATE:
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_OTHER:
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyContribution(
        contribution as BillingsPlanEntryTaxiDriverAddParamsPenaltyContribution,
      );
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.BASE_AMOUNT_EXTERNAL_TAXI:
    case BillingsPlanEntryTaxiDriverAddParamsContributionType.CONTRACT_CORRECTION_RATE:
      return createBillingContractCorrectionContribution(
        contribution as BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContribution,
      );
  }
};

const createBillingContributions = (
  contributions: BillingsPlanEntryTaxiDriverAddParamsContribution[],
): BillingsPlanEntryTaxiDriverAddRequestContribution[] => {
  return contributions.map(createBillingContribution);
};

const createBillingNode = (
  node: BillingsPlanEntryTaxiDriverAddParamsBillingNode,
): BillingsPlanEntryTaxiDriverAddRequestBillingNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeId,
    orderId: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createBillingNodes = (
  nodes: BillingsPlanEntryTaxiDriverAddParamsBillingNode[],
): BillingsPlanEntryTaxiDriverAddRequestBillingNode[] => {
  return nodes.map(createBillingNode);
};

const create = (
  params: BillingsPlanEntryTaxiDriverAddParams,
): BillingsPlanEntryTaxiDriverAddRequest => {
  return {
    billingContributions: createBillingContributions(
      params.billingContributions,
    ),
    billingNodes: createBillingNodes(params.billingNodes),
    planEntryId: params.planEntryId,
  };
};

const billingsPlanEntryTaxiDriverAddParamsFactory = {
  create,
};

export default billingsPlanEntryTaxiDriverAddParamsFactory;
